import Config from '../../utils/Configuration';
import HyperLink from '../../global/HyperLink';
import {ReactComponent as MaxisBusinessLogo} from './maxis-business-logo.svg';
import {ReactComponent as MaxisLogo} from './maxis-logo.svg';

import {ReactComponent as MaxisBusinessLogoMobile} from './maxis-business-logo-mobile.svg';
import {ReactComponent as LoginLogo} from './login-logo.svg';
import {ReactComponent as OrderTrackerLogo} from './order-tracker-logo.svg';
import {ReactComponent as CurrentLocationIcon} from './currentLocationIcon.svg';
import {ReactComponent as IconsInfo} from './icons-info.svg';
import {ReactComponent as GreenInfo} from './green-info-icon.svg';
import {ReactComponent as GreenSearch} from './green-search-icon.svg';
import {ReactComponent as CloseIconSearch} from './close-icon-search.svg';
import {ReactComponent as CloseIconGray} from './close-icon-gray.svg';
import {ReactComponent as IconsError} from './icons-error.svg';
import {ReactComponent as Search} from './search.svg';
import {ReactComponent as SearchIcon} from './search_icon.svg';
import {ReactComponent as MapPointer} from './mapPointer.svg';
import {ReactComponent as MapPointerError} from './mapPointerError.svg';
import {ReactComponent as AppleLogo} from './apple-logo.svg';
import {ReactComponent as PlayStoreLogo} from './play-store-logo.svg';
import {ReactComponent as HuaweiLogo} from './huawei-logo.svg';
import {ReactComponent as FacebookLogo} from './facebook-logo.svg';
import {ReactComponent as InstagramLogo} from './instagram-logo.svg';
import {ReactComponent as YoutubeLogo} from './youtube-logo.svg';
import {ReactComponent as XLogo} from './twitter-logo.svg';
import {ReactComponent as LinkedinLogo} from './linkedin-logo.svg';
import {ReactComponent as PlusIcon} from './plus-sign-logo.svg';
import {ReactComponent as BurgerMenu} from './burger-menu.svg';
import {ReactComponent as CrossMenu} from './cross-menu.svg';
import {ReactComponent as AccordionArrow} from './accordion-arrow.svg';
import {ReactComponent as DropDownArrow} from './dropdown-arrow.svg';
import {ReactComponent as KeyboardArrowDown} from './keyboard_arrow_down.svg';
import {ReactComponent as KeyboardArrowUp} from './keyboard_arrow_up.svg';
import {ReactComponent as HistoryIcon} from './history-icon.svg';
import {ReactComponent as BackArrowBlack} from './back-arrow-black.svg';
import {ReactComponent as SearchFrogGreen} from './search-frog-green.svg';
import {ReactComponent as SearchIconBlack} from './search-icon-black.svg';
import {ReactComponent as ArrowGreenLeft} from './arrow-green-left.svg';
import {ReactComponent as ArrowGreenRight} from './arrow-green-right.svg';
import {ReactComponent as CloseBlack} from './close-black.svg';
import {ReactComponent as GreenCheckIcon} from './green-check.svg';
import {ReactComponent as CircularGreenCheckIcon} from './circular-green-check.svg';
import {ReactComponent as RedXErrorIcon} from './red-X.svg';
import {ReactComponent as AuthTemplateSquigMobile} from './authTemplateSquigMobile.svg';
import {ReactComponent as AuthTemplateSquig} from './authTemplateSquig.svg';
import {ReactComponent as BackArrowMobile} from './back_mobile.svg';
import {ReactComponent as BackArrowDesktop} from './back_desktop.svg';
import {ReactComponent as ShowPassword} from './showPassword.svg';
import {ReactComponent as DropdownArrow} from './dropdownArrow.svg';
import {ReactComponent as LightBub} from './lightBub.svg';
import {ReactComponent as BlueInfoIcon} from './blueInfoIcon.svg';
import {ReactComponent as CheckboxChecked} from './checkboxChecked.svg';
import {ReactComponent as CalendarIcon} from './calendar.svg';
import {ReactComponent as LeftArrow} from './left-arrow.svg';
import {ReactComponent as RightArrow} from './right-arrow.svg';
import {ReactComponent as RightArrowLightGreen} from './arrow-green.svg';
import {ReactComponent as SilverRightArrow} from './silver-right-arrow.svg';
import {ReactComponent as SilverRightArrowMobi} from './silver-right-arrow-mobi.svg';
import {ReactComponent as SmallArrowheadBackward} from './small-arrowhead-backward.svg';
import {ReactComponent as SmallArrowheadForward} from './small-arrowhead-forward.svg';
import {ReactComponent as DeleteIcon} from './deleteIcon.svg';
import {ReactComponent as PenEditIcon} from './penEditIcon.svg';
import {ReactComponent as CartIconGreen} from './cart-green.svg';
import {ReactComponent as CartIcon} from './cart.svg';
import {ReactComponent as GreenGiftIcon} from './greenGiftIcon.svg';
import {ReactComponent as AssistanceIcon} from './assistance.svg';
import {ReactComponent as OrderTrackingBgSvg} from './orderTrackingBgSvg.svg';
import {ReactComponent as TickSelect} from './tickSelect.svg';
import {ReactComponent as BlueSliderArrowRight} from './blueSliderArrowRight.svg';
import {ReactComponent as BlueSliderArrowLeft} from './blueSliderArrowLeft.svg';
import {ReactComponent as CartItemAddOnPlus} from './cartItemAddOnPlus.svg';
import {ReactComponent as CheckCircle} from './check-circle.svg';
import {ReactComponent as CustomerInfoBgSvg} from './customerInfoBgSvg.svg';
import {ReactComponent as WhatsAppIcon} from './whatsAppIcon.svg';
import {ReactComponent as IconsInfoTooltip} from './icons-info-tooltip.svg';
import { ReactComponent as AlertCircleError } from './alert-circle-error.svg';
import {ReactComponent as CopyIcon} from './icon-copy.svg';


const consumerLink = Config.maxisConsumerSiteUrl;

const LinkedMaxisBusinessLogo = ({link, linkClass, ...props}) => (
    <HyperLink url={link || consumerLink}>
        <MaxisBusinessLogo {...props} />
    </HyperLink>
);

const LinkedMaxisBusinessLogoNoText = ({link, linkClass, ...props}) => (
    <HyperLink url={link || consumerLink} className={linkClass}>
        <MaxisLogo {...props} />
    </HyperLink>
);

export {
    MaxisBusinessLogo,
    MaxisLogo,
    LoginLogo,
    OrderTrackerLogo,
    CurrentLocationIcon,
    IconsInfo,
    GreenInfo,
    GreenSearch,
    CloseIconSearch,
    CloseIconGray,
    IconsError,
    Search,
    SearchIcon,
    MapPointer,
    MapPointerError,
    MaxisBusinessLogoMobile,
    LinkedMaxisBusinessLogo,
    LinkedMaxisBusinessLogoNoText,
    AppleLogo,
    PlayStoreLogo,
    HuaweiLogo,
    FacebookLogo,
    InstagramLogo,
    YoutubeLogo,
    XLogo,
    LinkedinLogo,
    PlusIcon,
    BurgerMenu,
    CrossMenu,
    AccordionArrow,
    DropDownArrow,
    KeyboardArrowDown,
    KeyboardArrowUp,
    HistoryIcon,
    BackArrowBlack,
    SearchFrogGreen,
    SearchIconBlack,
    ArrowGreenLeft,
    ArrowGreenRight,
    CloseBlack,
    GreenCheckIcon,
    CircularGreenCheckIcon,
    RedXErrorIcon,
    AuthTemplateSquigMobile,
    AuthTemplateSquig,
    BackArrowMobile,
    BackArrowDesktop,
    ShowPassword,
    DropdownArrow,
    LightBub,
    BlueInfoIcon,
    CheckboxChecked,
    CalendarIcon,
    LeftArrow,
    RightArrow,
    RightArrowLightGreen,
    SilverRightArrow,
    SilverRightArrowMobi,
    SmallArrowheadBackward,
    SmallArrowheadForward,
    DeleteIcon,
    PenEditIcon,
    CartIconGreen,
    CartIcon,
    GreenGiftIcon,
    AssistanceIcon,
    OrderTrackingBgSvg,
    TickSelect,
    BlueSliderArrowRight,
    BlueSliderArrowLeft,
    CartItemAddOnPlus,
    CheckCircle,
    CustomerInfoBgSvg,
    WhatsAppIcon,
    IconsInfoTooltip,
    AlertCircleError,
    CopyIcon
};
